import { Button, Modal, Badge } from 'react-bootstrap';
import ReactApexChart from 'react-apexcharts';

const ViewStock = ({ show, onClose }) => {
    const chartOptions = {
        title: {
            text: "Tomato - Total Qty vs Consumed Qty (August)",
            align: "center",
            style: {
                fontFamily: "poppins",
                fontSize: '15px',
                fontWeight: 500,
                color: '#ff0000',
            },
        },
        chart: {
            id: "comparison-chart",
            type: "bar",
            height: 350,
            stacked: false,
            toolbar: {
                show: true,
                tools: {
                    download: true,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                },
            },
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: "45%",
                endingShape: "rounded",
            },
        },
        xaxis: {
            title: {
                text: "Date (August)",
                style: {
                    fontFamily: "poppins",
                    fontSize: '15px',
                    fontWeight: 'semi-bold',
                    color: '#333',
                },
            },
            categories: ["1 Aug", "4 Aug", "7 Aug", "10 Aug", "13 Aug", "16 Aug", "19 Aug", "22 Aug", "25 Aug", "28 Aug"],
            labels: {
                style: {
                    fontSize: "12px",
                    colors: ["#333"],
                },
            },
        },
        yaxis: {
            title: {
                text: "Qty/Units",
                style: {
                    fontFamily: "poppins",
                    fontSize: '15px',
                    fontWeight: 'semi-bold',
                    color: '#333',
                },
            },
        },
        colors: ["#3ab384", "#ff7f50"], // Total qty = green, Consumed qty = coral
        tooltip: {
            shared: true,
            intersect: false,
        },
        legend: {
            position: "top",
            horizontalAlign: "center",
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: "12px",
                colors: ["#fff"],
            },
        },
    };

    const series = [
        {
            name: "Total Qty",
            data: [50, 48, 45, 44, 42, 40, 38, 37, 35, 33],
        },
        {
            name: "Consumed Qty",
            data: [10, 12, 15, 14, 13, 15, 16, 14, 13, 12],
        },
    ];

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <div className='d-flex align-items-center gap-3 flex-wrap'>
                        <h3 className="modal-title text-white">View Stock</h3>
                        <div className="ms-1 me-1 fw-bold">-</div>
                        <Badge bg="none" className='py-1 px-2 fs-4 border border-white text-white'>Tomato</Badge>
                    </div>
                    <Button variant="" type="button" className="close px-6 py-2 text-white" onClick={onClose}>
                        <span>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <ReactApexChart
                        options={chartOptions}
                        series={series}
                        type="bar"
                        height={350}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ViewStock;